import { ORDERS_PARTNER_FILTER_EVENTS } from '../../config';

export default {
  created() {
    const unwatch = this.$store.watch(
      (_, getters) => getters['currentUserModule/getCurrentUserId'],
      (newVal) => {
        if (newVal) {
          this.partnerFilterOptions.splice(1, 0, {
            id: newVal,
            name: 'Тільки головна точка',
            event: ORDERS_PARTNER_FILTER_EVENTS.ORDERS_PARTNER_FILTER_MAIN,
            options: {
              type: 'checkbox',
              multiselect: false,
            }
          });

          this.$eventBus.$on(
            ORDERS_PARTNER_FILTER_EVENTS.ORDERS_PARTNER_FILTER_MAIN,
            (item) => { this.setSelectedFilter('partner', item.id); }
          );

          unwatch();
        }
      }
    );
  },
  beforeDestroy() {
    this.$eventBus.$off(
      ORDERS_PARTNER_FILTER_EVENTS.ORDERS_PARTNER_FILTER_MAIN,
      (item) => { this.setSelectedFilter('partner', item.id); }
    );
  }
};
